import styled from 'styled-components';

type Positioning = {
  direction: string;
  align: string;
  justify: string;
};

export const PositioningInput = ({
  direction,
  align,
  justify,
  onChange,

  label,
}: {
  direction: string;
  align: string;
  justify: string;
  onChange: (positioning: Positioning) => void;

  label?: string;
}) => {
  const updateValue = (
    key: 'direction' | 'align' | 'justify',
    newValue: string
  ) => {
    const newPositioning = { direction, align, justify, [key]: newValue };
    onChange(newPositioning);
  };

  return (
    <Container>
      <label>{label}</label>

      <ButtonsContainer>
        <div className="leftSide">
          <IconGroup>
            <IconButton
              $active={direction === 'row'}
              onClick={() => {
                if (direction === 'row') return;

                const newPositioning = {
                  direction: 'row',
                  align: justify,
                  justify: align,
                };
                onChange(newPositioning);
              }}
            >
              <i className="icon-row" />
            </IconButton>
            <IconButton
              $active={direction === 'column'}
              onClick={() => {
                if (direction === 'column') return;

                const newPositioning = {
                  direction: 'column',
                  align: justify,
                  justify: align,
                };
                onChange(newPositioning);
              }}
            >
              <i className="icon-row" style={{ transform: 'rotate(90deg)' }} />
            </IconButton>
          </IconGroup>
        </div>
        <div className="rightSide">
          <Row>
            <IconGroup>
              <IconButton
                $active={align === 'flex-start'}
                onClick={() => updateValue('align', 'flex-start')}
              >
                <i
                  className="icon-positioning-left"
                  style={{ transform: 'rotate(90deg)' }}
                />
              </IconButton>
              <IconButton
                $active={align === 'center'}
                onClick={() => updateValue('align', 'center')}
              >
                <i
                  className="icon-positioning-center"
                  style={{ transform: 'rotate(90deg)' }}
                />
              </IconButton>
              <IconButton
                $active={align === 'flex-end'}
                onClick={() => updateValue('align', 'flex-end')}
              >
                <i
                  className="icon-positioning-right"
                  style={{ transform: 'rotate(90deg)' }}
                />
              </IconButton>

              {direction === 'column' && (
                <>
                  <IconButton
                    $active={align === 'space-between'}
                    onClick={() => updateValue('align', 'space-between')}
                  >
                    <i
                      className="icon-positioning-space-between"
                      style={{ transform: 'rotate(90deg)' }}
                    />
                  </IconButton>
                  <IconButton
                    $active={align === 'space-around'}
                    onClick={() => updateValue('align', 'space-around')}
                  >
                    <i
                      className="icon-positioning-space-around"
                      style={{ transform: 'rotate(90deg)' }}
                    />
                  </IconButton>
                </>
              )}
            </IconGroup>
          </Row>
          <Row>
            <IconGroup>
              <IconButton
                $active={justify === 'flex-start'}
                onClick={() => updateValue('justify', 'flex-start')}
              >
                <i className="icon-positioning-left" />
              </IconButton>
              <IconButton
                $active={justify === 'center'}
                onClick={() => updateValue('justify', 'center')}
              >
                <i className="icon-positioning-center" />
              </IconButton>
              <IconButton
                $active={justify === 'flex-end'}
                onClick={() => updateValue('justify', 'flex-end')}
              >
                <i className="icon-positioning-right" />
              </IconButton>

              {direction === 'row' && (
                <>
                  <IconButton
                    $active={justify === 'space-between'}
                    onClick={() => updateValue('justify', 'space-between')}
                  >
                    <i className="icon-positioning-space-between" />
                  </IconButton>
                  <IconButton
                    $active={justify === 'space-around'}
                    onClick={() => updateValue('justify', 'space-around')}
                  >
                    <i className="icon-positioning-space-around" />
                  </IconButton>
                </>
              )}
            </IconGroup>
          </Row>
        </div>
      </ButtonsContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 5px;
  padding-bottom: 10px;
  gap: 5px;

  label {
    padding-right: 10px;

    font-size: 11px;
    font-weight: 400;
    color: var(--text-color-secondary);

    white-space: nowrap;
  }
`;

const IconButton = styled.button<{ $active?: boolean }>`
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 5px;
  border: 1px solid var(--input-border-color);
  font-size: 14px;
  line-height: 14px;
  color: var(--text-color-secondary);

  &:hover {
    background-color: var(--panel-bg-color-hover);
  }

  ${({ $active }) =>
    $active &&
    'background-color: var(--panel-bg-color); color: var(--accent-color)'}
`;

const IconGroup = styled.div`
  display: flex;
  gap: 2px;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;

  .leftSide {
    max-width: 110px;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rightSide {
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
`;
